import React from "react";
import { capitalize } from "lodash";
import { CSVLink } from "@/components/ReactCSV";
import { PatientEncounter } from "@/resources/types";
import { Button } from "@mui/material";
import { getEncounterStatusForDisplaying } from "@/global";

const HEADERS = [
  { label: "ID", key: "id" },
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Status", key: "status" },
  { label: "Sex", key: "sex" },
  { label: "Gender", key: "gender" },
  { label: "Date of Birth", key: "dob" },
  { label: "UMRN", key: "umrn" },
  { label: "Email", key: "email" },
  { label: "Phone Number", key: "phoneNum" },
  { label: "Medicare Number", key: "medicareNum" },
  { label: "Medicare Number Position", key: "medicareNumPos" },
  { label: "Location", key: "location" },
  { label: "Pain Score", key: "painScore" },
  { label: "Fraily Score", key: "frailtyScore" },
  { label: "ATS Score", key: "atsScore" },
];

interface ExportRecordButtonProps {
  encounter: PatientEncounter;
  hidden?: boolean;
}

const ExportRecordButton = React.forwardRef((props: ExportRecordButtonProps, ref) => {
  const { encounter, hidden } = props;
  const { patient } = encounter;
  if (!patient) return <></>;
  const firstName = capitalize(patient.firstName);
  const lastName = capitalize(patient.lastName);
  const filename = `Patient Record - ${firstName} ${lastName}.csv`;
  const { displayStatus } = getEncounterStatusForDisplaying(encounter);


  const data = [{
    id: encounter.id,
    firstName,
    lastName,
    status: displayStatus,
    sex: patient.sex,
    gender: patient.gender,
    dob: patient.dateOfBirth,
    umrn: patient.umrn,
    email: patient.email,
    phoneNum: patient.phone,
    medicareNum: patient.medicareNo,
    medicareNumPos: patient.medicareNoPos,
    location: encounter.location?.name,
    painScore: encounter.pain,
    frailtyScore: encounter.frailty,
    atsScore: encounter.atsScore
  }];

  return (
    <CSVLink
      filename={filename}
      data={data}
      headers={HEADERS}
      ref={ref as any}
      hidden={hidden}
    >
      <Button
        variant="outlined"
        sx={{ gap: 1 }}
      >
        Export patient record
      </Button>
    </CSVLink>
  );
});

ExportRecordButton.displayName = "ExportRecordButton";
export default ExportRecordButton;
